(function () {
  angular.module('app.widgets.common.ie-eleven-notification').component('appIeElevenNotification', {
    controller,
    templateUrl: 'app/widgets/common/ie-eleven-notification/ie-eleven-notification.component.html',
  });

  /* @ngInject */
  function controller(_, IE11_BANNER_DISMISSED, storageUtils) {
    const vm = this;

    _.assign(vm, {
      $onInit,
      close,
    });

    function $onInit() {
      updateNotificationVisibility();
    }

    function close() {
      dismissBanner();
      updateNotificationVisibility();
    }

    ////////

    function dismissBanner() {
      storageUtils.setLocalStorageItem(IE11_BANNER_DISMISSED, true);
    }

    function shouldShowNotice() {
      return !wasBannerDismissed();
    }

    function updateNotificationVisibility() {
      vm.showNotice = shouldShowNotice();
    }

    function wasBannerDismissed() {
      return _.isEqual(storageUtils.getLocalStorageItem(IE11_BANNER_DISMISSED), true);
    }
  }
})();
